import { isUseFilterDefault } from 'utils/user';

export const ordersFiltersDefault = {
  OrdersId: [],
  WmsTransactionsId: [],
  PoNumber: [],
  Status: [],
  NegotiationTypes: [],
  SupplierIds: [],
  BusinessUnitIds: [],
  MaterialGroupIds: [],
  MaterialsNumber: [],
  CollectDateMin: '',
  CollectDateMax: '',
  DeliveryDateMin: '',
  DeliveryDateMax: '',
  DeliveryTimeMin: '',
  DeliveryTimeMax: '',
  PendingItems: false,
  UseFilterDefault: isUseFilterDefault(),
  _page: 0,
  _size: 50
}
